export const GQL_QUERIES = {
    ...require("./dashboard"),
    ...require("./application"),
    ...require("./manageapp-sidebar"),
    ...require("./manageapp-assignunassign"),
    ...require("./report"),
    ...require("./reviewers"),
    ...require("./criteria"),
    ...require("./rubrics"),
    ...require("./search"),
    ...require("./applicantAttributes"),
    ...require("./exports"),
    ...require("./system-messages"),
};